import { Box, Typography } from '@mui/material';
import { FieldProps } from '@rjsf/utils';
import { colors } from '@src/styles';

const monoFontFamily = "'JetBrains Mono', monospace";

export const EnumChipsField = (props: FieldProps) => {
  const options = ((props.schema.items as { enum?: unknown[] } | undefined)?.enum ?? []).map(String);
  const selected = Array.isArray(props.formData) ? (props.formData as unknown[]).map(String) : [];
  const isDisabled = Boolean(props.disabled || props.readonly);

  const toggle = (option: string) => {
    const next = selected.includes(option) ? selected.filter((value) => value !== option) : [...selected, option];
    props.onChange(
      options.filter((value) => next.includes(value)),
      props.fieldPathId.path,
    );
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, width: '100%', marginBottom: 1 }}>
      <Box
        role="group"
        aria-label={String(props.schema.title ?? props.name ?? '')}
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}
      >
        {options.map((option) => {
          const isSelected = selected.includes(option);
          return (
            <Box
              key={option}
              component="button"
              type="button"
              className="schema-custom-button"
              aria-pressed={isSelected}
              disabled={isDisabled}
              onClick={() => toggle(option)}
              sx={{
                height: 30,
                paddingX: 1.25,
                borderRadius: '999px',
                cursor: isDisabled ? 'default' : 'pointer',
                fontFamily: monoFontFamily,
                fontSize: '11.5px',
                color: isSelected ? colors.primary.yellow : colors.brand.textSecondary,
                backgroundColor: isSelected ? 'rgba(255, 160, 21, 0.12)' : colors.brand.surface,
                border: `1px solid ${isSelected ? 'rgba(255, 160, 21, 0.5)' : colors.brand.line}`,
                opacity: isDisabled && !isSelected ? 0.45 : 1,
                transition: 'border-color 0.15s ease, background-color 0.15s ease',
                '&:hover': isDisabled ? undefined : { borderColor: colors.primary.yellow },
              }}
            >
              {option}
            </Box>
          );
        })}
      </Box>
      {!isDisabled && props.required && selected.length === 0 && (
        <Typography sx={{ fontSize: '11.5px', color: colors.status.pending }}>
          Selecione pelo menos uma opção.
        </Typography>
      )}
    </Box>
  );
};
